import styled from "@emotion/styled";

export const InlineButtonWrapper = styled.span`
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;
